import createAxios from "./axiosHttp";

function loadRouteStopsByVehiclePlan(planId, vehicleId) {
  const axios = createAxios();
  const urlPath = `ttmm_app/plan/${planId}/vehicle/${vehicleId}/route-stop`;
  return axios.get(urlPath);
}

const finalizeSuffixByMode = {
  TaskScan: "finalize-scan",
  LoadUnload: "finalize-load-unload",
};

function finalizeRouteStop(planId, routeStopId, mode, payload) {
  const axios = createAxios();
  const suffix = finalizeSuffixByMode[mode] || "finalize";
  const urlPath = `ttmm_app/plan/${planId}/route-stop/${routeStopId}/${suffix}`;
  return axios.put(urlPath, payload);
}

async function loadRouteTasksByStop(routeStopId) {
  const axios = createAxios();
  const urlPath = `ttmm_app/stop/${routeStopId}/task`;
  const payload = await axios.get(urlPath);
  return Array.isArray(payload) ? payload : [];
}

export const mobileRouteService = {
  loadRouteStopsByVehiclePlan,
  finalizeRouteStop,
  loadRouteTasksByStop,
};
